export default "__VITE_ASSET__B3yo$F7e__"